import { render } from "./mensajeregalos_ingles.vue?vue&type=template&id=5c1a547a&scoped=true"
import script from "./mensajeregalos_ingles.vue?vue&type=script&lang=js"
export * from "./mensajeregalos_ingles.vue?vue&type=script&lang=js"

import "./mensajeregalos_ingles.vue?vue&type=style&index=0&id=5c1a547a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1a547a"]])

export default __exports__